// extracted by mini-css-extract-plugin
export default {"trigger":"yaF-4","skeleton-progress":"et09-"};